

  <div class="row d-flex">
    <div class="col-12">
      Como anexar um documento:
      <ul style="list-style:none;">
        <li>- Para adicionar um documento obrigatório que já está identificado na lista <strong style="text-decoration:underline">Documentação a enviar</strong>, carregar na imagem <strong style="text-decoration:underline">+</strong> no final do registo; </li>
        <li>- Para adicionar um documento adicional que não está identificado na lista <strong style="text-decoration:underline">Documentação a enviar</strong> carregar na opção <strong style="text-decoration:underline">(+) Adicionar documento</strong>;</li>
        <li>- Selecionar o tipo de documento que pretende adicionar no campo Designação. Caso tenha selecionado a opção Elementos Clínicos ou Outros, terá de especificar qual o documento a anexar;</li>
        <li>- Arrastar da pasta do seu posto de trabalho o ficheiro que pretende adicionar ou obter o ficheiro pretendido através da opção <strong style="text-decoration:underline">procure aqui</strong>;</li>
        <li>- Tenha atenção às regras do nome do ficheiro: Limite de 30 caracteres não acentuados, sem espaços e sem os caracteres ~ # % &amp; &#x7b; &#x7d; ” * : &lt; &gt; ? / \ |.</li>
        <li>- No campo Observações adicionar alguma informação complementar, finalizando a anexação do documento pressionando o botão <strong style="text-decoration:underline">Aplicar</strong>.</li>
      </ul>
    </div>

  </div>


